import Layout from '../../components/layout/Layout'
import { ASSETS } from '@/constants/assets'

const AIArchitecture = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Simplicity of AI Agents Architecture
        </h1>
        <div className="mt-8">
          <div className="relative">
            <img
              src={ASSETS.images.architectureDiagram}
              alt="Architecture diagram showing the interaction flow between Human, LLM Call, Environment, and Stop components with Action and Feedback loops"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <p className="mt-2 text-sm text-foreground/70">
            Autonomous agent diagram
          </p>
          <p className="mt-6 text-foreground text-lg leading-relaxed">
            We recommend focusing on two key aspects of the implementation: tailoring these capabilities to your specific use case and ensuring they provide an easy, well-documented interface for your LLM. While there are many ways to implement these augmentations, one approach is through our recently released Model Context Protocol, which allows developers to integrate with a growing ecosystem of third-party tools with a simple client implementation.
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default AIArchitecture 